/* src/app/components/study-room/study-room.component.scss */
:host {
  flex-direction: column;
}
.second-level-menu {
  background: #fff;
  height: 100%;
  max-height: 92vh;
  width: calc(100% - 30px) !important;
  margin: 10px auto;
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
}
.homework_wrapper table td.list-ellipsis {
  max-width: 250px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.homework_wrapper table td {
  overflow: hidden;
}
.homework_wrapper table {
  font-size: 14px;
}
.homework_wrapper .button .fa {
  font-size: 15px !important;
}
.homework_wrapper .button {
  border-radius: 30px;
  width: 31px;
  height: 31px;
  border: none;
}
.topicListView .button:hover {
  background-color: #3e55a1;
  color: #ffffff !important;
}
.topicListView .button .fa:hover {
  color: #fff;
}
/*# sourceMappingURL=study-room.component.css.map */
